import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header";
import { useTranslation } from "@/hooks/useTranslation";
import { Badge } from "@/components/ui/badge";
import { ReferralDTO } from "@shaarp/common";
import { ColumnDef } from "@tanstack/react-table";

export const dataTableReferralsColumns = () => {
  const { t } = useTranslation();

  return [
    {
      id: "name",
      accessorKey: "name",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("referrals.dataTable.columns.name")}
        />
      ),
      cell: ({ row }) => {
        const referral = row.original;
        return <span className="font-medium">{referral.name}</span>;
      },
    },
    {
      id: "inviteDate",
      accessorKey: "createdAt",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("referrals.dataTable.columns.inviteDate")}
        />
      ),
      cell: ({ row }) => {
        const referral = row.original;
        return <span>{new Date(referral.createdAt).toLocaleString()}</span>;
      },
    },
    {
      id: "status",
      accessorKey: "status",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("referrals.dataTable.columns.status")}
        />
      ),
      cell: ({ row }) => {
        const referral = row.original;
        const getStatusVariant = (status: string) => {
          switch (status) {
            case "pending":
              return "secondary";
            case "subscribed":
              return "success";
            case "not_subscribed":
              return "destructive";
            default:
              return "secondary";
          }
        };

        return (
          <Badge variant={getStatusVariant(referral.status)}>
            {t(`referrals.dataTable.status.${referral.status}`)}
          </Badge>
        );
      },
    },
  ] as ColumnDef<ReferralDTO>[];
};
